import { ClockErrorsLog } from "Types";
import DSBaseTable, {
  Column,
} from "views/system-design/Table/DSBaseTable/components/DSBaseTable";
import DSTableCell from "views/system-design/Table/DSTableCell";
import DSCollapsibleText from "views/system-design/DSCollapsibleText";

interface LogsGridProps {
  logs: ClockErrorsLog[];
}

const columns: Column<ClockErrorsLog>[] = [
  {
    field: "version",
    label: "Version",
    size: 80,
    sortable: true,
  },
  {
    field: "log",
    label: "Log",
    size: 500,
    sortable: false,
  },
  {
    field: "timestamp",
    label: "Last Occurrence",
    size: 160,
    sortable: true,
  },
  {
    field: "id",
    label: "Clock ID",
    size: 120,
    sortable: false,
  },
  {
    field: "occurrences",
    label: "Occurrences",
    size: 100,
    sortable: true,
  },
];

const formatDate = (value: string) => {
  if (!value) return "";
  const date = new Date(value);
  return date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
};

const LogsGrid = ({ logs }: LogsGridProps) => {
  const rowBuilder = (
    row: ClockErrorsLog,
    columns: Column<ClockErrorsLog>[],
  ) => (
    <>
      {columns.map((column) => (
        <DSTableCell
          key={column.field as string}
          sx={{
            fontSize: 12,
            width: column.size || "auto",
            whiteSpace: column.field === "log" ? "normal" : "nowrap",
            wordBreak: column.field === "log" ? "break-word" : "normal",
          }}
        >
          {column.field === "log" ? (
            <DSCollapsibleText text={row.log} maxLines={3} />
          ) : column.field === "timestamp" ? (
            formatDate(row.timestamp)
          ) : (
            String(row[column.field])
          )}
        </DSTableCell>
      ))}
    </>
  );

  return (
    <DSBaseTable
      data={logs}
      columns={columns}
      rowBuilder={rowBuilder}
      defaultRowsPerPage={25}
    />
  );
};

export default LogsGrid;
